import React, { useEffect } from 'react'
import Loadable from '../../../../components/loadable/Loadable'
import styles from "./SubmitFormForMultiplePayers.styles"

import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setIsAllCheckBoxChecked, setIsCheckBoxChecked, setPaginationState, setScheduleDate, setSelectedPayer } from './SubmitFormForMultiplePayersSlice'
import { LABEL_WEIGHT } from '../../../../components/label/constants'
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants'

import Popup from '../../../../components/popup/Popup'
import CalendarInput from '../../../../components/input/calendarinput/CalendarInput'
import RichGrid from '../../../../components/richgrid/RichGrid'
import Label from '../../../../components/label/Label'
import CheckboxWLabel from '../../../../components/checkbox/checkboxwlabel/CheckboxWLabel'
import Checkbox from '../../../../components/checkbox/basecheckbox/Checkbox'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import { getListofAllPayersPaymentDetails, getSubmitAllPayersGridList, setCheckboxSubmitForAllPayer } from './SubmitFormForMultiplePayersSaga'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import Button from '../../../../components/button/Button'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import CalendarInputWDateFormat from '../../../../components/input/calendarinput/CalendarInputWDateFormat'
import { componentKey as dataLoaderKey } from '../../../loaders/dataloader/DataLoaderSlice'
import { componentKey as formsListingComponentkey } from '../FormListingSlice'
import {CHECKBOX_FIELD_NAMES, STATE_FORMS} from './constants'
import { useState } from 'react'
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import DateUtils from '../../../../../libs/utility/DateUtils'
import InformationPopup from '../../../../components/popup/informationpopup/InformationPopup'
import General from '../../../../../libs/utility/General'
import { PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../../constants/constants'

const SubmitFormForMultiplePayers = ({ isOpen = false, onCloseCb = () => { }, selectedForm = {}, taxYear = "" }) => {

    useGarbageCollector(componentKey)
    const dispatch = useDispatch()

    const { loadingState, scheduleDate, paginationState, selectedPayer, payerPaymentList } = useSelector(state => state[componentKey]);

    const { enableScheduleDate } = useSelector(state => state[formsListingComponentkey]);
    const { formsScheduleDates } = useSelector(state => state[dataLoaderKey]);

    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [showNoneSelectionConfirmationPopup, setShowNoneSelectionConfirmationPopup] = useState(false);
    const [showSelectionConfirmationPopup, setShowSelectionConfirmationPopup] = useState(false);
    const [selectedExtendedScheduleDate, setSelectedExtendedScheduleDate] = useState(null);

    const [selectedFormScheduleDetails, setSelectedFormScheduleDetails] = useState({})

    useEffect(() => {
        if (selectedForm?.FormLabel) {
            const selectedFormScheduleDetails = formsScheduleDates?.formScheduleDates.find(form => form.FormName === selectedForm?.FormLabel)
            setSelectedFormScheduleDetails(selectedFormScheduleDetails)
        }
    }, [formsScheduleDates, selectedForm])

    useEffect(() => {
        dispatch(getSubmitAllPayersGridList({ FormNameId: selectedForm.value, FormName: selectedForm.label, TaxYear: taxYear, FormStatus: "NotSubmitted" }))
    }, [])

    const handleCheck = ({ name, checked, index, payer }) => {
        dispatch(setCheckboxSubmitForAllPayer({name, checked, index, payer, taxYear, formId: selectedForm.value, formName: selectedForm.label, formStatus: "NotSubmitted" }))
    }


    const USER_COLUMNS = [
        {
            field: "payerName",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer Name</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{`${row?.PayerName}`}</span>
        },
        {
            field: "uspsMail",
            header: <CheckboxWLabel 
                name={CHECKBOX_FIELD_NAMES.IS_USPS} 
                label="USPS Mail" 
                checked={payerPaymentList?.every(item => item?.IsUsps)} 
                disabled={selectedPayer.length < payerPaymentList.length}
                onChangeCb={({ target: { name, checked } }) => handleCheck({ name: name, checked: checked, index: -1, payer: 0 })} 
                weight={LABEL_WEIGHT[700]} 
            />,

            renderLogic: (row, idx) => <span style={styles.text}>
                <Checkbox
                    name={CHECKBOX_FIELD_NAMES.IS_USPS}
                    checked={row.IsUsps}
                    onChangeCb={({ target: { name, checked } }) => handleCheck({ name: name, checked: checked, index: idx, payer: row.PayerDetailId })}
                    disabled={!selectedPayer.find( payer => payer.PayerDetailId === row.PayerDetailId)}
                />
            </span>
        },
        {
            field: "emailRecipient",
            header: <CheckboxWLabel 
                name={CHECKBOX_FIELD_NAMES.IS_EMAIL_RECIPIENT}
                label="eDelivery" 
                checked={payerPaymentList?.every(item => item?.IsEmailRecipient)} 
                disabled={selectedPayer.length < payerPaymentList.length}
                onChangeCb={({ target: { name, checked } }) => handleCheck({ name: name, checked: checked, index: -1, payer: 0 })} 
                weight={LABEL_WEIGHT[700]} 
            />,
            renderLogic: (row, idx) => <span style={styles.text}>
                <Checkbox
                    name={CHECKBOX_FIELD_NAMES.IS_EMAIL_RECIPIENT}
                    checked={row.IsEmailRecipient}
                    onChangeCb={({ target: { name, checked } }) => handleCheck({ name: name, checked: checked, index: idx, payer: row.PayerDetailId })}
                    disabled={!selectedPayer.find( payer => payer.PayerDetailId === row.PayerDetailId)}
                />
            </span>
        },
        {
            field: "tinMatch",
            header: <CheckboxWLabel 
                name={CHECKBOX_FIELD_NAMES.IS_TIN_CHECK}
                label="TIN Match" 
                checked={payerPaymentList?.every(item => item?.IsTinCheck)} 
                disabled={selectedPayer.length < payerPaymentList.length}
                onChangeCb={({ target: { name, checked } }) => handleCheck({ name: name, checked: checked, index: -1, payer: 0 })} 
                weight={LABEL_WEIGHT[700]} 
            />,
            renderLogic: (row, idx) => <span style={styles.text}>
                <Checkbox
                    name={CHECKBOX_FIELD_NAMES.IS_TIN_CHECK}
                    checked={row.IsTinCheck}
                    onChangeCb={({ target: { name, checked } }) => handleCheck({ name: name, checked: checked, index: idx, payer: row.PayerDetailId })}
                    disabled={!selectedPayer.find( payer => payer.PayerDetailId === row.PayerDetailId)}
                />
            </span>
        },
        {
            field: "stateFiling",
            header: <CheckboxWLabel 
                name={CHECKBOX_FIELD_NAMES.IS_STATE_FILLING} 
                label="State Filing" 
                checked={payerPaymentList?.every(item => item?.IsStateFilling)}
                disabled={selectedPayer.length < payerPaymentList.length}
                onChangeCb={({ target: { name, checked } }) => handleCheck({ name: name, checked: checked, index: -1, payer: 0 })} 
                weight={LABEL_WEIGHT[700]} 
            />,
            renderLogic: (row, idx) => <span style={styles.text}>
                <Checkbox
                    name={CHECKBOX_FIELD_NAMES.IS_STATE_FILLING}
                    checked={row.IsStateFilling}
                    onChangeCb={({ target: { name, checked } }) => handleCheck({ name: name, checked: checked, index: idx, payer: row.PayerDetailId })}
                    disabled={!General.isStateForm(selectedForm?.FormLabel.replace("-", "")) || !selectedPayer.find( payer => payer.PayerDetailId === row.PayerDetailId)}
                />
            </span>
        },
        {
            field: "scheduleDate",
            header: <Label weight={LABEL_WEIGHT[700]}>Schedule Date</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{`${row?.SheduledDate}`}</span>
        },
    ];

    const handleRowSelection = (selectedData, indx) => {
        // Create sets of PayerDetailId values from both selectedPayer and selectedData
        const payerDetailIdsSet = new Set(selectedPayer.map(item => item.PayerDetailId));
        const dataDetailIdsSet = new Set(selectedData.map(item => item.PayerDetailId));

        // Find the first object that is not in either of the arrays
        let updatedPayer = null;

        for (const payerObject of selectedPayer) {
            if (!dataDetailIdsSet.has(payerObject.PayerDetailId)) {
                updatedPayer = payerObject;
                break;
            }
        }

        if (!updatedPayer) {
            for (const dataObject of selectedData) {
                if (!payerDetailIdsSet.has(dataObject.PayerDetailId)) {
                    updatedPayer = dataObject;
                    break;
                }
            }
        }

        if(selectedPayer.length > selectedData.length) {
            //UnChecked a Payer
            handleCheck({ name: CHECKBOX_FIELD_NAMES.IS_PAYER , checked: false, index: indx, payer: updatedPayer.PayerDetailId })
        } else {
            //Checked a Payer
            handleCheck({ name: CHECKBOX_FIELD_NAMES.IS_PAYER, checked: true, index: indx, payer: updatedPayer.PayerDetailId })
        }

        dispatch(setSelectedPayer(selectedData))
        
    }

    const handleChangeScheduleDate = (e) => {
        if(new Date(e) > DateUtils.getMomentObject(selectedFormScheduleDetails.ScheduledDate)) {
            setShowConfirmationPopup(true)
            setSelectedExtendedScheduleDate(e)
        } else {
            dispatch(setScheduleDate(e))
        }
    }

    const Body = (
        <Loadable currentState={loadingState.state} loadingStates={PAGE_STATE.LOADING} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
            <div style={styles.calendar}>
                <CalendarInputWDateFormat
                    label={"Schedule Date"}
                    value={scheduleDate}
                    inputClassName="w-100"
                    onChangeCb={(e) => handleChangeScheduleDate(e)}
                    allowOnlyFutureDate={true}
                    maxAllowedDate={DateUtils.getMomentObject(formsScheduleDates?.maxScheduleDateAllowed)}
                    disabled={!enableScheduleDate}
                />
            </div>

            <RichGrid
                data={payerPaymentList}
                columns={USER_COLUMNS}
                selectable={true}
                extractRowKey={(row) => row.PayerDetailId}
                onSelectionChangeCallBack={(selectedData, indx) => {
                    handleRowSelection(selectedData, indx)
                }}
                onHeaderSelectionChangeCallBack={(selectedData) => {
                    dispatch(setSelectedPayer(selectedData))
                    handleCheck({ name: CHECKBOX_FIELD_NAMES.IS_PAYER, checked: selectedData.length > 0, index: -1, payer: 0 })
                }}
                selectedRows={selectedPayer}
                paginationProps={{
                    skip: paginationState?.Skip,
                    take: paginationState?.PageSize,
                    takeOptions: ROW_SELECTION_OPTIONS,
                    onChangeTakeCb: (newTake) => {
                        dispatch(setPaginationState({ ...paginationState, PageSize: newTake, Page: 1, Skip: 0 }));
                    },
                    total: paginationState?.totalPayer,
                    onChange: (take, t) => {
                        dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, Page: Math.ceil((take + Skip) / take) }))
                    },
                }}
            />
            <div style={styles.footer}>
                <Button
                    type={BUTTON_TYPE.PRIMARY}
                    style={styles.buttons}
                    onClickCb={() => {
                        if (scheduleDate && selectedPayer.length > 0) {
                            const validSelections = payerPaymentList.filter( payer => payer.IsPayer && (payer.IsEmailRecipient || payer.IsStateFilling || payer.IsTinMatch || payer.IsUsps))
                            if(validSelections.length > 0) {
                                setShowSelectionConfirmationPopup(true)
                            } else {
                                setShowNoneSelectionConfirmationPopup(true)
                            }
                        } else if (selectedPayer.length === 0) {
                            dispatch(addNotifications({ heading: "Error", message: "Please select payer" }))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select schedule date" }))
                        }
                    }}
                >
                    Submit
                </Button>

                <Button
                    type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                    style={styles.buttons}
                    onClickCb={onCloseCb}
                >
                    Cancel
                </Button>
            </div>
        </Loadable>
    )

    return (
        <>
            <Popup
                isPopupOpen={isOpen}
                title={"Submit For Multiple Payers"}
                onCloseCb={onCloseCb}
                children={Body}
                childrenStyles={styles.popupBody}
                customPopupSyles={styles.overlayStyles}
            />
            <InformationPopup
                title={"Important Alert!"}
                bodyText={`${DateUtils.dateFormatter(selectedFormScheduleDetails.ScheduledDate, "MMMM DD, YYYY")} marks the final deadline for filing your ${selectedForm?.FormLabel} as per the Internal Revenue Service. Please be aware that any further delay may result in potential penalties.`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={showConfirmationPopup}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        setShowConfirmationPopup(false)
                        dispatch(setScheduleDate(selectedExtendedScheduleDate))
                    },
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                showClose={false}
            />
            <ConfirmationPopup 
                title={"Please Note"}
                bodyText={"You have not chosen either USPS Mail or eDelivery. You may use Manage Forms to send email, USPS mail, or print copies of the Recipient 1099/W2. Click Cancel to make those selections now or Continue if you plan to notify the Recipient separately."}
                iconName = {VEC_ICON_NAME.WARNING_ICON}
                isOpen={showNoneSelectionConfirmationPopup}
                confirmationButtonProps = {{
                    onConfirmationCb: () => {
                        setShowNoneSelectionConfirmationPopup(false)
                        setShowSelectionConfirmationPopup(true)
                    },
                    confirmationButtonText: "Continue",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps = {{
                    onCancelCb: () => setShowNoneSelectionConfirmationPopup(false),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                } }
                showClose={false}
            />

            <ConfirmationPopup 
                title={"Please Note"}
                bodyText={`I have reviewed and verified the data for submission of ${selectedPayer.length} Payers. I understand that unless the eFile schedule date is in the future, this request cannot be modified after this.`}
                isOpen={showSelectionConfirmationPopup}
                confirmationButtonProps = {{
                    onConfirmationCb: () => {
                        setShowSelectionConfirmationPopup(false)
                        dispatch(getListofAllPayersPaymentDetails({ FormNameId: selectedForm.value, TaxYear: taxYear, FormStatus: "Not Submitted", ScheduleDate: scheduleDate }))
                    },
                    confirmationButtonText: "Continue",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps = {{
                    onCancelCb: () => setShowSelectionConfirmationPopup(false),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                } }
                showClose={false}
            />
        </>
        )
}

export default SubmitFormForMultiplePayers
